import { PlaceData } from '../enums/maps';
import { generateId } from '../utils';
import { BaseModel } from './base';


export enum SUBMISSION_STATUS {
    EN_COURS = 'EN_COURS',
    ACCEPTE = 'ACCEPTE',
    REFUSE = 'REFUSE'
}



export interface Submission extends BaseModel {
    name: string;
    tel: string,
    email: string,
    emplacement: string | PlaceData,
    description: string,
    created: string | null;
    files: number[] | null;
    franchiseId: ModelId | null,
    relancer: string | null,
    debutTravaux: string | null,
    rcs: number | null,
    status: string | null,
    hash: string | null,
    notes: string | null,
    archived: boolean | null,
    gclid: string | null,
    fbclid: string | null,
}

export const newSubmission: Submission = {
    id: 0,
    name: '',
    tel: '',
    email: '',
    emplacement: '',
    description: '',
    created: null,
    files: [],
    franchiseId: null,
    relancer: null,
    debutTravaux: null,
    rcs: null,
    status: SUBMISSION_STATUS.EN_COURS,
    hash: generateId(45),
    notes: null,
    archived: false,
    gclid: null,
    fbclid: null,
};
